module.exports = __webpack_public_path__ + "static/img/43_default_avatar.dac949c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/enterprise/43_default_avatar.png
// module id = 496
// module chunks = 39